import React, { useState } from 'react'
import {
  Grid,
  Table,
  TableHeaderRow,
  TableColumnResizing,
} from '@devexpress/dx-react-grid-bootstrap4'
import {
  Column,
  TableColumnWidthInfo,
  SortingState,
  IntegratedSorting,
} from '@devexpress/dx-react-grid'
import { Track } from '../types/AnalyticsProps'
import formatCurrency from '../utils/formatCurrency'

interface TopTracksTableProps {
  data: Track[]
}

const TopTracksTable: React.FunctionComponent<TopTracksTableProps> = ({ data }) => {
  const columns: ReadonlyArray<Column> = [
    { name: 'track_title', title: 'Track Title' },
    { name: 'track_artist', title: 'Artist' },
    { name: 'isrc', title: 'ISRC' },
    { name: 'total', title: 'Value' },
  ]

  const columnWidths: TableColumnWidthInfo[] = [
    { columnName: 'track_title', width: 'auto' },
    { columnName: 'track_artist', width: 'auto' },
    { columnName: 'isrc', width: 'auto' },
    { columnName: 'total', width: 'auto' },
  ]

  const [columnExtensions] = useState<Array<Table.ColumnExtension>>([
    { columnName: 'total', align: 'right' },
  ])

  const TableCell = ({ value, column }: any) => {
    if (column.name === 'total') {
      return <td className='text-right'>{formatCurrency(value)}</td>
    }
    return <td>{value}</td>
  }

  return (
    <>
      <h4>Top Tracks</h4>
      <Grid rows={data} columns={columns}>
        <SortingState />
        <IntegratedSorting />
        <Table cellComponent={TableCell} columnExtensions={columnExtensions} />
        <TableColumnResizing defaultColumnWidths={columnWidths} resizingMode='nextColumn' />
        <TableHeaderRow showSortingControls />
      </Grid>
    </>
  )
}

export default TopTracksTable
